import { ErrorHandler, NgModule } from '@angular/core';
import { GlobalErrorHandler } from './error.handler';
import { ErrorService } from './error.service';

/**
 * Error module.
 */
@NgModule({
  providers: [
    { provide: ErrorHandler, useClass: GlobalErrorHandler },
    ErrorService
  ]
})
export class ErrorModule {}
